import React, { useEffect, useState } from 'react'
import { Box, Card, CardContent, CircularProgress, Drawer, IconButton, List, ListItem, Paper, Typography } from "@mui/material"
import { useDispatch } from "react-redux";
// icons
import CloseIcon from '@mui/icons-material/Close';
// utils and helpers
import { formatTimestampToDateView } from "utilities/common";
import { getPlannerOverrideNotes } from "../../../redux/slices/hyperwolf/inventoryDistribution";
// custom components
import { showToastMsg } from "components/distributionSetting/distributionManagement/addRegionKit";

export default function PlannerNotes({ open, TransitionComponent, handleClose, templateData }) {
  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState(false);
  const [plannersNotes, setPlannerNotes] = useState([]);

  const handleGetPlannerNotes = async () => {
    setIsLoading(true)
    try {
      const response = await dispatch(getPlannerOverrideNotes(templateData?._id)).unwrap();
      if (response?.data) {
        setPlannerNotes(response?.data || []);
      }
    }
    catch (error) {
      showToastMsg(error)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (open) {
      handleGetPlannerNotes();
    }
  }, [open]);

  return (
    <Drawer
      open={open}
      TransitionComponent={TransitionComponent}
      keepMounted
      className="cus-drawer low-stock-products-drawer"
      onClose={handleClose}
      anchor='right'
      sx={{
        "& .MuiDrawer-paper": {
          maxWidth: "800px !important"
        }
      }}
    >
      <Box p={{ sm: 2 }}>
        <Box className='drawer-head-sec d-flex align-item-center jc-s-btwn' mb={1} sx={{ minHeight: "auto !important" }}>
          <Typography variant='h4' fontWeight='semibold'>Planner Override Notes</Typography>
          <IconButton onClick={handleClose} edge='end' size='small'>
            <CloseIcon fontSize='medium' />
          </IconButton>
        </Box>

        <List sx={{ display: "flex", flexWrap: "wrap", columnGap: 2, rowGap: 1, mb: 3 }}>
          <ListItem sx={{ width: "auto" }}>
            <Typography variant="body2" fontWeight="medium" color="#656575" style={{ whiteSpace: "nowrap" }}>Template ID:</Typography>
            <Typography variant="body2" fontWeight="semibold" ml={1}>{templateData.templateId}</Typography>
          </ListItem>
          <ListItem sx={{ width: "auto" }}>
            <Typography variant="body2" fontWeight="medium" olor="#656575" style={{ whiteSpace: "nowrap" }}>Region:</Typography>
            <Typography variant="body2" fontWeight="semibold" ml={1}>{templateData?.region?.region}</Typography>
          </ListItem>
          <ListItem sx={{ width: "auto" }}>
            <Typography variant="body2" fontWeight="medium" olor="#656575" style={{ whiteSpace: "nowrap" }}>Sub Region:</Typography>
            <Typography variant="body2" fontWeight="semibold" ml={1}>
              {templateData?.subRegions?.map(subRegion => subRegion?.name)?.join(", ")}
            </Typography>
          </ListItem>
        </List>

        <Box sx={{ height: "calc(100svh - 145px)", overflow: "auto" }}>
          {
            isLoading ?
              <Paper sx={{ p: 2.5, boxShadow: "none", display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center", height: "100%" }}><CircularProgress /></Paper>
              : plannersNotes.map(notes => (
                <Paper key={notes._id} sx={{ mt: 1.5, p: 2.5, bgcolor: "#F5F5FF", borderRadius: "0.75rem", boxShadow: "none" }} elevation={0}>
                  <Typography variant="caption" component="p" fontWeight={500} color={"#8E0CF5"}>Updated By: {notes.updatedBy}</Typography>
                  <Typography variant="body2" component="p" fontWeight={500} my={1} color={"#2E2E3A"}>{notes.note}</Typography>
                  <Typography variant="caption" component="p" fontWeight={500} color={"#656575"}>{formatTimestampToDateView(notes.timestamp)}</Typography>
                </Paper>
              ))
          }
        </Box>
      </Box>
    </Drawer>
  )
}
